import React, { useEffect } from 'react';
import {
  isSelectionExpanded,
  useEditorSelector,
} from '@udecode/plate-common';
import {
  ELEMENT_IMAGE,
  floatingMediaActions,
  useFloatingMediaSelectors,
} from '@udecode/plate-media';
import { useReadOnly, useSelected } from 'slate-react';
import { offset } from '@floating-ui/react';

import { PlateFloatingImage } from './PlateFloatingImage';
import { Popover } from '../../components/popup/Floating/ElementPopover';


export function MediaPopover({ children, floatingOptions }) {
  const readOnly = useReadOnly();
  const selected = useSelected();

  const selectionCollapsed = useEditorSelector(
    (editor) => !isSelectionExpanded(editor),
    [],
  );
  const isOpen = !readOnly && selected && selectionCollapsed;
  const isEditing = useFloatingMediaSelectors().isEditing();

  const defaultFloatingOpts = {
    middleware: [
      offset(({ rects }) => {
        const gutter = 5;
        return {
          mainAxis: -(rects.floating.width + gutter),
          crossAxis: -(gutter),
        };
      }),
    ],
    placement: 'top-end',
  };

  useEffect(() => {
    if (!isOpen && isEditing) {
      floatingMediaActions.isEditing(false);
    }
  }, [isOpen]);

  if (readOnly) return <>{children}</>;

  return (
    <Popover
      modal={false}
      open={isOpen}
      content={<PlateFloatingImage pluginKey={ELEMENT_IMAGE} />}
      floatingOptions={{
        ...defaultFloatingOpts,
        ...floatingOptions,
        open: isOpen,
      }}
    >
      {children}
    </Popover>
  );
}
